export default "__VITE_ASSET__C6Q4PLjs__"